module.exports = __webpack_public_path__ + "img/total-count-widget.1d87b5e8.png";